// Externe Bibliotheken
import React, { Component, memo } from 'react';

// Interne Module
import * as storage from '@/_helper/storage';

// Styles
import './sideNavigation.scss';

// Komponenten
import { Link } from 'react-router';

class SideNavigation extends Component {
    state = {};

    constructor(props) {
        super(props);

        const bookingData = storage.get('bookingData');
        const bookingNumber = storage.get('bookingNumber');

        if (bookingData?.data) {
            this.state.data = bookingData.data;
            this.state.bookingData = bookingData;
        }

        if (bookingNumber) {
            this.state.bookingNumber = bookingNumber;
        }

        //deactivateServices();
    }

    getNavigationItems() {
        const items = this.props.navigationList.map((item) => {
            return (
                <Link
                    className={'tab ' + (this.props.currentStep === item.index ? 'active' : '')}
                    key={item.index}
                    to={`/${item.name}`}>
                    <i className="tab-icon material-symbols-outlined">{item.icon}</i>
                    <span className="title">{item.label}</span>
                    {item.alertCount !== undefined && item.alertCount !== 0 && (
                        <span className="alert-count">{item.alertCount}</span>
                    )}
                    {window.$browserInfo.device === 'mobile' && (
                        <i className="tab-arrow material-symbols-outlined">arrow_forward_ios</i>
                    )}
                </Link>
            );
        });

        return items;
    }

    render() {
        return this.getNavigationItems();
    }
}

export default memo(SideNavigation);
